import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ICU from "i18next-icu";

import Langs from "./langs";

i18n
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    resources: Langs,

    defaultNS: "translation",

    interpolation: {
      escapeValue: false,
    },

    react: {
      wait: true,
    },
  });

i18n.normalizedLanguage = () => {
  let lang = window.language || navigator.language;

  if (lang.toUpperCase().startsWith("FR")) return "fr";
  if (lang.toUpperCase().startsWith("EN")) return "en";
  if (lang.toUpperCase().startsWith("NL")) return "nl";

  return "en";
};

export default i18n;
